__turbopack_context__.v({
  "className": "roboto_9013426c-module__LoKjMW__className",
});
